import React from 'react';
import Image from 'react-bootstrap/Image';
import Header from './Header';
import Slide from 'react-reveal/Slide';

const Clientes = (props) => {



    return (
        <div className="col-md-12">
            <Slide top>
                <div className='fixed-top' >
                    <Header />
                </div>
            </Slide>
            <div className='col-md-12 contenedor-principal container-fluid p-0' id='contenedorTotal' >
                {/*  <img className='img-fluid' src='imagenes/compu1.jpg' /> */}
                <div className='hover-principal mx-auto row'></div>
                <Slide top>
                    <div className='contenedor-principal-content row contenedor-fluid'>


                        <h1 className='text-center fw-bold'>CLIENTES</h1>





                    </div>
                </Slide>


            </div>
            <div className='col-md-12 mx-auto row py-5'>
                <Slide bottom>

                    <h1 className='text-center mt-5'>Clientes de la empresa</h1>

                    <div className='col-md-8 mx-auto'>
                        <h3 className='text-center'>
                            Son varias las instituciones del sector público y privado que han confiado su gestión
                            administrativa y contable, a los productos y servicios de SYGRE,C.A.       </h3>
                    </div>
                </Slide>
            </div>
        </div>

    );
};

export default Clientes;


// WEBPACK FOOTER //
// ./src/components/clientes.js